
import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'
import { Vessel } from '@/models/Vessel'
import { Attribute } from '@/models/Attribute'
import AttributeItem from '@/components/Preferences/AttributeItem.vue'
import AttributeCategory from '@/enums/AttributeCategory'
import AttributeGroup from '@/enums/AttributeGroup'
import { namespace } from 'vuex-class'

const AttributesStore = namespace('attributes')

@Component({
	components: {
		AttributeItem
	}
})
export default class AttributeEditor extends Vue {
	@Prop({ required: true })
	vessel!: Vessel

	@Prop({ required: true })
	category!: AttributeCategory

	@AttributesStore.Action('loadAttributes')
	triggerLoad

	@AttributesStore.State('attributes')
	loadedAttributes!: Array<any>

	@AttributesStore.State('loading')
	isLoadingAttributes!: Array<any>

	async created() {
		await this.loadAttributes()
	}

	get groupedAttributes(): Record<string, Array<Attribute>> {
		const groupedWithSorted = this.loadedAttributes
			.filter((attribute) => attribute.subCategory === this.category)
			.reduce((acc, curr) => {
				const group = curr.group?.length ? curr.group : AttributeGroup.UNGROUPED
				if (!acc[group]) {
					acc[group] = []
				}

				acc[group] = [...acc[group], curr]
				return acc
			}, {})

		const sortOrder = [
			AttributeGroup.HOLD,
			AttributeGroup.GENERAL,
			AttributeGroup.SUSTAINABILITY,
			AttributeGroup.CERTIFICATE,
			AttributeGroup.PREFERENCES,
			AttributeGroup.UNGROUPED
		]

		const orderedGroupedAttributes = sortOrder.reduce((acc, key) => {
			if (groupedWithSorted[key]) {
				acc[key] = groupedWithSorted[key]
			}
			return acc
		}, {})

		Object.keys(orderedGroupedAttributes).forEach((key) => {
			if (!(key in orderedGroupedAttributes)) {
				orderedGroupedAttributes[key] = groupedWithSorted[key]
			}
		})

		return orderedGroupedAttributes
	}

	async loadAttributes() {
		await this.triggerLoad()
	}

	async validate() {
		return await this.$validator.validateAll()
	}
}
